export default "__VITE_ASSET__CZ3WiCA1__"